import { Pipe, PipeTransform } from '@angular/core';

export interface Contextualized {
  contextProvider?: (x: any) => any;
}

/**
 * It transform provided `data` using a `contextProvided` function (from params)
 * to return a contextualized object; else return the `data` as is
 */
@Pipe({
  name: 'contextualized',
  standalone: false,
})
export class ContextualizedPipe implements PipeTransform {
  public static doTransform(data: any, args: { contextProvider?: (x: any) => any }) {
    return typeof args?.contextProvider === 'function' ? args.contextProvider(data) : data;
  }

  transform(data: any, args) {
    return ContextualizedPipe.doTransform(data, args);
  }
}
